import { html, LitEntity } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import '../../common/bn-action';
import '../../common/bn-flash';
import '../../common/bn-loading';
import '../../common/bn-placeholder';
import './location-delegate';

class LocationDelegateModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'location-delegate-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#${this.id} {
          --modal-min-width: 40%;
          --modal-max-width: 600px;
        }
      </style>
      <h3 slot="title">Delegate Work Order Location</h3>
      <location-delegate .href="${this.href}" @response="${this._onResponse}"></location-delegate>
    `;
  }

  _onResponse(e) {
    this.dispatchEvent(new CustomEvent('response'), { detail: e.detail, bubbles: true, composed: true });
    setTimeout(this.close, 1000);
  }
}

window.customElements.define('location-delegate-modal', LocationDelegateModal);
